import React, { useState } from "react";
import {
  Input,
  Label,
  Alert,
  TooltipButton,
  Tooltip,
  GlyphInfo,
} from "@americanexpress/dls-react";
import { useTranslation } from "react-i18next";

const PaymentInputForm = (props) => {
  const { t } = useTranslation("common");
  const formData = props.data;
  const [touched, setTouched] = useState({
    fundingAcc: false,
    maxToken: false,
    dailyToken: false,
    maxSpend: false,
    thresholdAmount: false,
    recepient: false,
  });

  const isValidNumber = (value, length) => {
    return length
      ? !isNaN(value) && value.length === length
      : !isNaN(value) && value.length !== 0;
  };

  const isValidEmail = (email) => {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*$/.test(
      email
    );
  };

  const isLowMaxSpend = (maxSpend, maxToken) => {
    if (Number(maxSpend) < Number(maxToken)) {
      return false;
    } else {
      return true;
    }
  };

  const isHighThreshold = (Threshold, maxToken) => {
    if (Number(Threshold) > Number(maxToken)) {
      return false;
    } else {
      return true;
    }
  };

  const isFormCompleted = () => {
    return (
      isValidNumber(formData.fundingAcc, 9) &&
      isValidNumber(formData.maxToken) &&
      isValidNumber(formData.dailyToken) &&
      isValidNumber(formData.maxSpend) &&
      isValidNumber(formData.thresholdAmount) &&
      isValidEmail(formData.recepient) &&
      isLowMaxSpend(formData.maxSpend, formData.maxToken) &&
      isHighThreshold(formData.thresholdAmount, formData.maxToken)
    );
  };

  return (
    <>
      <div className="paymentalert">
        {formData.fundingAcc === "" ||
        formData.maxToken === "" ||
        formData.dailyToken === "" ||
        formData.maxSpend === "" ||
        formData.maxToken === "" ||
        formData.thresholdAmount === "" ||
        formData.recepient === "" ||
        isFormCompleted() === false ? (
          <Alert>Please fill the details</Alert>
        ) : null}
      </div>

      <div className="VpaymentWrapper">
        <div className="inputCorporateIdWrapper">
          <Label>
            {t("access.fundingacc")}
            <span className="inputCorporateIdTooltip">
              <Tooltip
                id="tooltip-default-top"
                triggerElement={
                  <TooltipButton icon={<GlyphInfo />} tabIndex="-1" />
                }
                placement="top"
              >
                {t("access.invalidcorp")}
              </Tooltip>
            </span>
          </Label>
          <Input
            className="inputCorporateId"
            placeholder={t("access.fundingacc")}
            maxLength="9"
            value={formData.fundingAcc}
            onChange={(event) => {
              setTouched({ ...touched, fundingAcc: true });
              formData.fundingAcc = event.target.value;
              props.dataChange(formData, isFormCompleted());
            }}
          />
          {touched.fundingAcc && !isValidNumber(formData.fundingAcc, 9) && (
            <Alert status="error">{t("access.fundingaccvalid")}</Alert>
          )}
        </div>
        <div className="inputCorporateIdWrapper">
          <Label>
            {t("access.maxlimit")}
            <span className="inputCorporateIdTooltip">
              <Tooltip
                id="tooltip-default-top"
                triggerElement={
                  <TooltipButton icon={<GlyphInfo />} tabIndex="-1" />
                }
                placement="top"
              >
                {t("access.maxdollar")}
              </Tooltip>
            </span>
          </Label>

          <Input
            className="inputCorporateId"
            placeholder={t("access.maxlimit")}
            value={formData.maxToken}
            maxLength="8"
            onChange={(event) => {
              setTouched({ ...touched, maxToken: true });
              formData.maxToken = event.target.value;
              props.dataChange(formData, isFormCompleted());
            }}
          />
          {touched.maxToken && !isValidNumber(formData.maxToken) && (
            <Alert status="error">{t("access.maxlimitvalid")}</Alert>
          )}
        </div>
        <div className="inputCorporateIdWrapper">
          <Label>
            {t("access.dailytokens")}
            <span className="inputCorporateIdTooltip">
              <Tooltip
                id="tooltip-default-top"
                triggerElement={
                  <TooltipButton icon={<GlyphInfo />} tabIndex="-1" />
                }
                placement="top"
              >
                {t("access.dailytokens")}
              </Tooltip>
            </span>
          </Label>
          <Input
            className="inputCorporateId"
            placeholder={t("access.dailytokens")}
            maxLength="15"
            value={formData.dailyToken}
            onChange={(event) => {
              setTouched({ ...touched, dailyToken: true });
              formData.dailyToken = event.target.value;
              props.dataChange(formData, isFormCompleted());
            }}
          />
          {touched.dailyToken && !isValidNumber(formData.dailyToken) && (
            <Alert status="error">{t("access.dailytokensvalid")}</Alert>
          )}
        </div>
        <div className="inputCorporateIdWrapper">
          <Label>
            {t("access.maxspend")}
            <span className="inputCorporateIdTooltip">
              <Tooltip
                id="tooltip-default-top"
                triggerElement={
                  <TooltipButton icon={<GlyphInfo />} tabIndex="-1" />
                }
                placement="top"
              >
                {t("access.maxvalue")}
              </Tooltip>
            </span>
          </Label>
          <Input
            className="inputCorporateId"
            placeholder={t("access.maxspend")}
            maxLength="8"
            value={formData.maxSpend}
            onChange={(event) => {
              setTouched({ ...touched, maxSpend: true });
              formData.maxSpend = event.target.value;
              props.dataChange(formData, isFormCompleted());
            }}
          />
          {touched.maxSpend &&
            !isLowMaxSpend(formData.maxSpend, formData.maxToken) && (
              <Alert status="error">{t("access.lessmaxlimit")}</Alert>
            )}
          {touched.maxSpend && !isValidNumber(formData.maxSpend) && (
            <Alert status="error">{t("access.maxspendvalid")}</Alert>
          )}
        </div>
        <div className="inputCorporateIdWrapper">
          <Label>
            {t("access.threshold")}
            <span className="inputCorporateIdTooltip">
              <Tooltip
                id="tooltip-default-top"
                triggerElement={
                  <TooltipButton icon={<GlyphInfo />} tabIndex="-1" />
                }
                placement="top"
              >
                {t("access.maxvalue")}
              </Tooltip>
            </span>
          </Label>
          <Input
            className="inputCorporateId"
            placeholder={t("access.threshold")}
            maxLength="8"
            value={formData.thresholdAmount}
            onChange={(event) => {
              setTouched({ ...touched, thresholdAmount: true });
              formData.thresholdAmount = event.target.value;
              props.dataChange(formData, isFormCompleted());
            }}
          />
          {touched.thresholdAmount &&
            !isHighThreshold(formData.thresholdAmount, formData.maxToken) && (
              <Alert status="error">{t("access.greatermaxlimit")}</Alert>
            )}
          {touched.thresholdAmount &&
            !isValidNumber(formData.thresholdAmount) && (
              <Alert status="error">{t("access.maxspendvalid")}</Alert>
            )}
        </div>
        <div className="inputCorporateIdWrapper">
          <Label>
            {t("access.notification")}
            <span className="inputCorporateIdTooltip">
              <Tooltip
                id="tooltip-default-top"
                triggerElement={
                  <TooltipButton icon={<GlyphInfo />} tabIndex="-1" />
                }
                placement="top"
              >
                {t("access.emailnotification")}
              </Tooltip>
            </span>
          </Label>
          <Input
            className="inputCorporateId"
            placeholder={t("access.notification")}
            value={formData.recepient}
            onChange={(event) => {
              setTouched({ ...touched, recepient: true });
              formData.recepient = event.target.value;
              props.dataChange(formData, isFormCompleted());
            }}
          />
          {touched.recepient && !isValidEmail(formData.recepient) && (
            <Alert status="error">{t("access.notificationvalid")}</Alert>
          )}
        </div>
      </div>
    </>
  );
};

export default PaymentInputForm;
